const ACTION_TYPES = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  SEND_ACTIVATION_EMAIL: 'SEND_ACTIVATION_EMAIL',
};

export default ACTION_TYPES;
